import React, { useState } from 'react';
import { Row, Col, Card, Typography, Button, Modal } from 'antd';
import { PlayCircleOutlined, CloseOutlined } from '@ant-design/icons';
import styles from './Accounting.module.css';

const { Title, Text } = Typography;

const AccountingGame = () => {
  const [entryGameVisible, setEntryGameVisible] = useState(false);
  const [identityGameVisible, setIdentityGameVisible] = useState(false);

  // 处理点击会计分录挑战游戏按钮
  const handlePlayEntryGame = () => {
    setEntryGameVisible(true);
  };

  // 处理点击财务报表解析游戏按钮
  const handlePlayIdentityGame = () => {
    setIdentityGameVisible(true);
  };

  // 关闭游戏模态框
  const handleCloseEntryGame = () => {
    setEntryGameVisible(false);
  };

  // 关闭游戏模态框
  const handleCloseIdentityGame = () => {
    setIdentityGameVisible(false);
  };

  return (
    <div className={styles.container}>
      <Title level={2} className={styles.pageTitle}>趣味会计</Title>
      <Text className={styles.pageDescription}>
        通过有趣的游戏方式学习会计知识，提高学习效率和记忆效果
      </Text>
      
      <Row gutter={[24, 24]} className={styles.gameCardsContainer}>
        <Col xs={24} sm={24} md={12}>
          <Card 
            hoverable
            className={styles.gameCard}
            cover={
              <div className={styles.gameCoverContainer}>
                <div className={styles.gameCover} style={{ backgroundColor: '#1890ff' }}>
                  <PlayCircleOutlined className={styles.gameIcon} />
                </div>
              </div>
            }
          >
            <Card.Meta
              title="会计分录挑战"
              description="通过游戏化的方式练习会计分录，提高记忆和应用能力"
            />
            <div className={styles.gameCardFooter}>
              <Button 
                type="primary" 
                size="large" 
                className={styles.playButton}
                onClick={handlePlayEntryGame}
              >
                开始游戏
              </Button>
              <div className={styles.gameStats}>
                <div className={styles.statItem}>
                  <span className={styles.statValue}>4.8</span>
                  <span className={styles.statLabel}>评分</span>
                </div>
                <div className={styles.statItem}>
                  <span className={styles.statValue}>2.5k+</span>
                  <span className={styles.statLabel}>已玩</span>
                </div>
              </div>
            </div>
          </Card>
        </Col>
        
        <Col xs={24} sm={24} md={12}>
          <Card 
            hoverable
            className={styles.gameCard}
            cover={
              <div className={styles.gameCoverContainer}>
                <div className={styles.gameCover} style={{ backgroundColor: '#52c41a' }}>
                  <PlayCircleOutlined className={styles.gameIcon} />
                </div>
              </div>
            }
          >
            <Card.Meta
              title="财务报表解析"
              description="学习如何分析财务报表，掌握财务分析的关键技能"
            />
            <div className={styles.gameCardFooter}>
              <Button 
                type="primary" 
                size="large" 
                className={styles.playButton}
                onClick={handlePlayIdentityGame}
              >
                开始游戏
              </Button>
              <div className={styles.gameStats}>
                <div className={styles.statItem}>
                  <span className={styles.statValue}>4.6</span>
                  <span className={styles.statLabel}>评分</span>
                </div>
                <div className={styles.statItem}>
                  <span className={styles.statValue}>1.8k+</span>
                  <span className={styles.statLabel}>已玩</span>
                </div>
              </div>
            </div>
          </Card>
        </Col>
      </Row>

      {/* 会计分录挑战游戏模态框 */}
      <Modal
        title="会计分录挑战"
        open={entryGameVisible}
        onCancel={handleCloseEntryGame}
        footer={null}
        width="90%"
        style={{ top: 20 }}
        className={styles.gameModal}
        closeIcon={<CloseOutlined className={styles.closeIcon} />}
      >
        <div className={styles.iframeContainer}>
          <iframe
            src="/game/entry/index.html"
            title="会计分录挑战"
            className={styles.gameIframe}
            allowFullScreen
          />
        </div>
      </Modal>

      {/* 财务报表解析游戏模态框 */}
      <Modal
        title="财务报表解析"
        open={identityGameVisible}
        onCancel={handleCloseIdentityGame}
        footer={null}
        width="90%"
        style={{ top: 20 }}
        className={styles.gameModal}
        closeIcon={<CloseOutlined className={styles.closeIcon} />}
      >
        <div className={styles.iframeContainer}>
          <iframe
            src="/game/identity/index.html"
            title="财务报表解析"
            className={styles.gameIframe}
            allowFullScreen
          />
        </div>
      </Modal>
    </div>
  );
};

export default AccountingGame; 